export default __webpack_public_path__ + "static/media/landing-record.b4ec3f26.png";